import { useNavigate } from 'react-router';
import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { CreateCategoryDto } from '../../../commonTypes/documents.types';

const useHttpInsertCategory = () => {
    const { t } = useTranslation('newNotifications');
    const navigate = useNavigate();
    const toastHandler = useContainer(ToastStateHandler);
    const userApi = useContainer(UserApi);

    const exec = (body: CreateCategoryDto) => {
        const { exec, abort } = userApi.createDocumentCategory({
            body,
            onSuccess: () => {
                navigate('/documents');
                toastHandler.push('success', t('categories.createTitle'), t('categories.createSuccess'));
            },
            onError: () => toastHandler.push('error', t('categories.createTitle'), t('categories.createError')),
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpInsertCategory;
